export default __webpack_public_path__ + "static/adventure@2x-c93ff332de6da52500674f24d65b50a7.png";